<template>
  <div class="contentArea">
    <base-dialog :show="successModal" small>
      <div class="success my-10">
        <img src="../assets/success.svg" alt="" />
        <h2 class="mt-10 text-white">{{ successText }}</h2>
      </div>
    </base-dialog>
    <form @submit.prevent="submitForm">
      <h2 class="mb-5">ข้อมูลผู้รับเงิน</h2>
      <div class="card">
        <div class="grid grid-cols-12 gap-y-3">
          <p class="col-span-2 col-start-1">ชื่อบัญชี :</p>
          <input
            class="col-span-4 w-10/12"
            type="text"
            v-model="acc_name"
            required
          />
          <p class="col-span-2 col-start-1">ธนาคาร :</p>
          <select tabindex="-1" class="col-span-4 w-10/12" v-model="bank" required>
            <option v-for="name in bankNameList" :key="name" :value="name">
              {{ name }}
            </option>
          </select>
          <p class="col-span-2 col-start-1">เลขบัญชี :</p>
          <input
            class="col-span-4 w-10/12"
            type="text"
            v-model="acc_number"
            required
          />
          <p class="col-span-2 col-start-1">สาขา :</p>
          <input
            class="col-span-4 w-10/12"
            type="text"
            v-model="branch"
            required
          />
        </div>
      </div>
      <div class="grid grid-cols-10 gap-4 mt-5">
        <vs-button
          class="col-end-10"
          color="#ffffff"
          text-color="#8d9498"
          @click="goBackPage"
        >
          ยกเลิก
        </vs-button>
        <vs-button class="col-end-11" button="submit" color="#15c1c3">
          บันทึก
        </vs-button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "../util/backend.js";
export default {
  data() {
    return {
      successModal: false,
      successText: "",
      bankNameList: [
        "SCB",
        "BBL",
        "KBANK",
        "UOB",
        "BAY",
        "KTB",
        "TMB",
        "TBANK",
        "CIMB",
        "LH",
      ],
      bank: "",
      acc_name: "",
      acc_number: "",
      branch: "",
    };
  },
  methods: {
    async submitForm() {
      if (!this.$route.params.id) {
        try {
          const res = await axios.post(
            `${baseUrl}/bankpayment/create`,
            {
              bank: this.bank,
              acc_name: this.acc_name,
              acc_number: this.acc_number,
              branch: this.branch,
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          if (res.data.status === "success") {
            this.successText = "สร้างสำเร็จ";
            this.successModal = true;
            setTimeout(() => {
              this.successModal = false;
              this.$router.replace("/bankpayment");
            }, 1000);
          } else {
            const error = new Error("สร้างบัญชีไม่สำเร็จ");
            throw error;
          }
        } catch (err) {
          alert(err);
        }
      } else {
        try {
          const res = await axios.post(
            `${baseUrl}/bankpayment/edit?bankpayment_id=${this.$route.params.id}`,
            {
              bank: this.bank,
              acc_name: this.acc_name,
              acc_number: this.acc_number,
              branch: this.branch,
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          if (res.data.status === "success") {
            this.successText = "แก้ไขสำเร็จ";
            this.successModal = true;
            setTimeout(() => {
              this.successModal = false;
              this.$router.replace("/bankpayment");
            }, 1000);
          } else {
            const error = new Error("แก้ไขบัญชีไม่สำเร็จ");
            throw error;
          }
        } catch (err) {
          alert(err);
        }
      }
    },
    goBackPage() {
      this.$router.go(-1);
    },
    async loadData() {
      if (this.$route.params.id) {
        const res = await axios.get(
          `${baseUrl}/bankpayment/get/?bankpayment_id=${this.$route.params.id}`,
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res.data.data);
        const accData = res.data.data;
        this.bank = accData.bank;
        this.acc_name = accData.acc_name;
        this.acc_number = accData.acc_number;
        this.branch = accData.branch;
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
h2 {
  color: #ffffff;
}

p {
  color: #ffffff;
}

.card {
  background-color: #4e5363;
  border-radius: 5px;
  padding: 35px;
}

input[type="number"],
input[type="text"],
select,
textarea {
  border-radius: 2px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

textarea {
  padding-top: 5px;
}

select,
input[type="number"],
input[type="text"] {
  height: 34px;
  min-width: 0;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
